import React from "react";
import CheckIcon from '../../assets/images/check-white.svg';
import { Image } from "../../components/componentIndex";
import { Button } from "common/commonIndex";
import LogoIcon from '../../assets/images/logo/Logo.svg';
import { useNavigate } from "react-router-dom";

const PracticeRegistrationUnderReview = () => {
    const navigate = useNavigate();

    const handleSubmit = () => {
        window.open('https://www.gutchek.io/contact', '_blank');
    }
    const handleLandingPage = () => {
        navigate('/landing');
    };
    return (
        <>
            <div className='login-header-logo' onClick={handleLandingPage}>
                <Image imgUrl={LogoIcon} altText={'logo'} className={'logo'} />
            </div>
            <hr />
            <div className="custom-container">
                <div className="referral-form">
                    <h4 className="page-title">Practice registration under review</h4>

                    <div className="row">
                        <div className="col-md-10">
                            <div className="message-content my-3">
                                <div className="success-circle">
                                    <Image imgUrl={CheckIcon} altText={'check'} />
                                </div>
                                <p className="success-message mb-0">Practice registration submitted successfully!</p>
                            </div>
                            <p className="received-message">Your practice registration has been received and is under review.</p>
                            <hr />
                            <div className="practice-verification-and-approval ">
                                <p className="practice-approval-title what-happens-next-title">What happens next?</p>
                                <ul className="what-happens-next">
                                    <li>Our team will <strong>verify your details within 24-48 hours.</strong></li>
                                    <li>If <strong>approved</strong>, you’ll receive a Welcome Email with next steps.</li>
                                    <li>If <strong>additional verification is needed</strong>, we’ll reach out via email.</li>
                                    <li>Once approved, you can <strong>complete your practice profile and add doctors.</strong></li>
                                    <li><strong>Payment is only required when adding doctors.</strong></li>
                                </ul>
                            </div>
                            <hr />
                            <p className="need-help">Need help?</p>
                            <div className="justify-content-start mb-4 mt-2">
                                <Button btnType={'submit'}
                                    btnClass={'btn-primary question-btn'}
                                    btnName={'Contact Support'}
                                    isDisabled={true}
                                    onClick={handleSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default PracticeRegistrationUnderReview;